import request from '@/common/utils/request';

export function login(data) {
    return request.post('/api/auth/login', data)
}

export function uploadImage(file) {
    let formData = new FormData();
    formData.append('file', file);
    return request.post('/api/upload/singleUpload', formData)
}

//新增藏品
export function addCreation(data) {
    return request.post('/api/collectionItems/add', data)
}

//更新藏品
export function updateCreation(data) {
    return request.put('/api/collectionItems/update', data)
}

//查询藏品列表
export function creationList(data) {
    return request.post('/api/collectionItems/list', data)
}

//删除藏品
export function deleteCreation(id) {
    return request.delete('/api/collectionItems/' + id)
}

//藏品详情
export function creationDetail(id) {
    return request.get('/api/collectionItems/' + id)
}


//新增关联
export function addBind(data) {
    return request.post('/api/binding/add', data)
}

//查询关联列表
export function bindList(data) {
    return request.post('/api/binding/list', data)
}

//取消关联
export function deleteBind(post) {
    return request.post('/api/binding/delete', post)
}